'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _es_ES = require('../../date-picker/locale/es_ES');

var _es_ES2 = _interopRequireDefault(_es_ES);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _es_ES2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/calendar/locale/es_ES.tsx
 ** module id = 761
 ** module chunks = 1
 **/